/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import type { FeaturesUsage } from '@modules/cloud-api/v1/types'
import type { BillingSubscriptionLevel } from '@modules/ui-types'

import { isUsageOutOfCompliance } from '@/lib/usage'

interface Props {
  featureUsage: FeaturesUsage
  overrideUsageLevel: BillingSubscriptionLevel | undefined
  isTrial: boolean
}

export const shouldShowFeatureUsageBanner = ({
  featureUsage,
  overrideUsageLevel,
  isTrial,
}: Props): boolean => {
  if (
    // If overrideUsageLevel is same with usage_level, we don't want to display duplicated banner.
    overrideUsageLevel &&
    overrideUsageLevel === featureUsage.usage_level
  ) {
    return false
  }

  const outOfCompliance = isUsageOutOfCompliance({
    subscriptionLevel: featureUsage.subscription_level,
    usageLevel: overrideUsageLevel || featureUsage.usage_level,
  })

  return outOfCompliance && !isTrial
}
